module.exports = __webpack_public_path__ + "static/img/weather-bg-2.0011973.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-2.gif
// module id = DIa0
// module chunks = 1